<template>
  <div class="negotiation-remark">
    <!-- 应商查看磋商记录 公司要改成采购商的 -->
    <div class="company-wrapper">
      <div>询价企业：{{ companyInfo.purchaseCompanyName }}</div>
    </div>
    <!-- 磋商item -->
    <div
      v-for="(item, index) in consultRecordQueryDetailVOList"
      :key="item.supplierOfferConsultId"
      class="negotiation-wrapper"
    >
      <div class="negotiation-title">{{ item.title }}</div>
      <div class="negotiation-info">
        <div v-if="item.title !== '首次报价信息'" class="negotiation-info-column">
          <div class="negotiation-info-item">
            <span class="label">磋商类型：</span>
            <el-radio-group v-model="item.consultationType" disabled class="negotiation-radio-group">
              <el-radio :label="0">供应商重新报价</el-radio>
              <el-radio :label="1">采购商填写报价</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="item.title !== '首次报价信息'" class="negotiation-info-column">
          <div class="negotiation-info-item">
            <span class="label">磋商发起时间：</span>
            <span>{{ item.createTime }}</span>
          </div>
          <div class="negotiation-info-item">
            <span class="label">磋商截至时间：</span>
            <span>{{ item.consultDeadline }}</span>
          </div>
        </div>
        <div class="negotiation-info-column">
          <div class="negotiation-info-item">
            <span class="label">报价时间：</span>
            <span>{{ item.offerCreateTime }}</span>
          </div>
          <div class="negotiation-info-item">
            <span class="label">报价有效期：</span>
            <span>{{ item.quotationValidity }}</span>
          </div>
        </div>
        <div v-if="item.title !== '首次报价信息'" class="negotiation-info-column">
          <div class="negotiation-info-item">
            <span class="label">备注信息：</span>
            <span>{{ item.consultRemark }}</span>
          </div>
        </div>
        <div v-if="item.title !== '首次报价信息'" class="negotiation-info-column">
          <div class="negotiation-info-item">
            <span class="label">磋商报价状态：</span>
            <span>{{ item.consultStatusDesc }}</span>
          </div>
          <div v-if="item.consultStatusDesc === '已拒绝'" class="negotiation-info-item">
            <span class="label">拒绝原因：</span>
            <span>{{ item.refuseReason }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.consultStatusDesc === '已报价' || item.consultationType === 1" class="negotiation-goods">
        <div class="negotiation-goods-title">供应商报价信息</div>
        <div class="negotiation-goods-list">
          <e-table-list ref="tableList" :table-data="item.tableData" :table-label="tableLabel"></e-table-list>
        </div>
        <div class="negotiation-goods-page">
          <el-pagination
            :current-page.sync="item.listQuery.pageNum"
            :page-size="item.listQuery.pageSize"
            layout="total, prev, pager, next"
            :total="item.total"
            @current-change="
              (val) => {
                handleCurrentChange(val, index, item);
              }
            "
          ></el-pagination>
          <!-- <e-page
            :page-index="listQuery.pageNum"
            :total="total"
            :page-size="listQuery.pageSize"
            @change=
          ></e-page> -->
        </div>
        <div class="negotiation-total-price">
          <span class="label">含税总金额：</span>
          <span class="money">{{ formatMoney(item.offerAmount) }} CNY</span>
        </div>
      </div>
    </div>
    <div class="btn-bottom">
      <el-button class="cancel" icon="el-icon-arrow-left" @click="toBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import ETableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order/index';

export default {
  components: { ETableList },
  data() {
    return {
      companyInfo: {},
      consultRecordQueryDetailVOList: [],
      tableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          mixWidth: '220px',
          fixed: 'left',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          mixWidth: '120px',
          fixed: 'left',
        },
        {
          label: '规格型号',
          param: 'specifications',
          align: 'center',
          mixWidth: '200px',
          fixed: 'left',
        },
        {
          label: '商品描述',
          param: 'productDescription',
          align: 'center',
          mixWidth: '200px',
        },
        {
          label: '商品类目',
          param: 'categoryName',
          align: 'center',
          mixWidth: '140px',
        },
        {
          label: '需求数量',
          param: 'requiredQuantity',
          align: 'center',
          mixWidth: '100px',
        },
        {
          label: '计量单位',
          param: 'unitName',
          align: 'center',
          mixWidth: '100px',
        },
        {
          label: '*报价单价（含税）',
          param: 'price',
          align: 'center',
          mixWidth: '140px',
          /* render: row => {
            return row.shippingCost ? row.shippingCost : "包邮";
          }, */
        },
        {
          label: '*税率（%）',
          param: 'taxRate',
          align: 'center',
          mixWidth: '120px',
        },
        { label: '运费', param: 'deliveryFee', align: 'center', mixWidth: '80px' },
        { label: '小计', param: 'totalPrice', align: 'center', mixWidth: '80px' },
      ],
    };
  },
  mounted() {
    this.getOfferConsultSupplierRecord();
  },
  methods: {
    async geList(index, item) {
      const result = await api.offerConsultRecordDetail({
        supplierOfferConsultId: item.supplierOfferConsultId,
        ...item.listQuery,
      });
      if (result.code === '200') {
        this.consultRecordQueryDetailVOList[index].tableData = [...result.data.records];
        this.consultRecordQueryDetailVOList[index].total = result.data.total;
      }
    },
    async getOfferConsultSupplierRecord() {
      const { enquiryId = '', supplierOfferId = '' } = this.$route.query;
      const result = await api.offerConsultSupplierRecord({
        enquiryId,
        supplierOfferId,
      });
      if (result.code === '200') {
        const { data } = result;
        const {
          consultRecordQueryDetailVOList = [],
          supplierCompany,
          supplierCompanyId,
          purchaseCompanyName,
          purchaseCompanyId,
        } = data;

        this.companyInfo = {
          supplierCompany,
          supplierCompanyId,
          purchaseCompanyName,
          purchaseCompanyId,
        };
        consultRecordQueryDetailVOList.forEach(async (item) => {
          item.listQuery = {
            pageNum: 1,
            pageSize: 10,
          };
          item.total = 0;
          item.tableData = [];
          const result = await api.offerConsultRecordDetail({
            supplierOfferConsultId: item.supplierOfferConsultId,
            ...item.listQuery,
          });
          if (result.code === '200') {
            item.tableData = [...result.data.records];
            item.total = result.data.total;
          }
        });
        this.consultRecordQueryDetailVOList = [...consultRecordQueryDetailVOList];
        console.log(this.consultRecordQueryDetailVOList);
      }
    },
    handleCurrentChange(val, index, item) {
      item.listQuery.pageNum = val;
      this.geList(index, item);
    },
    toBack() {
      this.$router.go(-1);
    },
    formatMoney(value, num) {
      num = num > 0 && num <= 20 ? num : 2;
      value = `${parseFloat(`${value}`.replace(/[^\d\.-]/g, '')).toFixed(num)}`; // 将金额转成比如 123.45的字符串
      const valueArr = value.split('.')[0].split('').reverse(); // 将字符串的数变成数组
      const valueFloat = value.split('.')[1]; // 取到 小数点后的值
      let valueString = '';
      for (let i = 0; i < valueArr.length; i++) {
        valueString += valueArr[i] + ((i + 1) % 3 == 0 && i + 1 != valueArr.length ? ',' : ''); // 循环 取数值并在每三位加个','
      }
      const money = `${valueString.split('').reverse().join('')}.${valueFloat}`; // 拼接上小数位
      return money;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.negotiation-remark {
  padding: 20px;
  background: $bg-color-2;
  .title {
    color: #333;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
  .company-wrapper {
    height: 56px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-top: 20px;
    font-size: 16px;
    border: 1px solid#D9D9D9;
  }
  .negotiation-wrapper {
    margin-top: 20px;
    border: 1px solid#D9D9D9;
    .negotiation-title {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 20px;
      background: #f5f5f5;
      border-bottom: 1px solid#D9D9D9;
      font-size: 14px;
    }
    .negotiation-info {
      padding-bottom: 20px;
      .negotiation-info-column {
        display: flex;
        margin-top: 20px;
        .negotiation-info-item {
          flex: 1;
          display: flex;
          padding-left: 20px;
          .label {
            flex-shrink: 0;
            flex-grow: 0;
            white-space: nowrap;
            width: 120px;
            flex-basis: 120px;
            text-align: right;
          }
        }
      }
    }
    .negotiation-goods {
      padding: 20px;
      border-top: 1px solid#D9D9D9;
      .negotiation-goods-title {
        font-size: 16px;
        padding-bottom: 20px;
      }
      .negotiation-goods-page {
        margin-top: 20px;
      }
      .negotiation-total-price {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .label {
          font-weight: bold;
          font-size: 16px;
        }
        .money {
          font-size: 18px;
          color: #f0250f;
        }
      }
    }
  }
  .btn-bottom {
    margin-top: 20px;
  }
}
</style>
